export default "__VITE_ASSET__BO1G0fs0__"